import { deleteDoc, doc } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { hideLoading, showLoading } from "./item-types-delete-slice";
import { deleteTypes } from "../item-types-list/item-types-list-slice";

// export const getItemTypesDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemTypesDelete getItemTypesDataService error: ", e);
//     }
// };

export const deleteItemTypesService = async (dispatch, db, coll, id) => {
    dispatch(showLoading());
    try {
        await deleteDoc(doc(db, coll, id));
        dispatch(deleteTypes(id));
        dispatch(showSuccessSnackbar('Deleted successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Delete failed! Please, try again.'));
        console.error("ItemTypesDelete deleteItemTypesService error: ", e);
    }
    dispatch(hideLoading());
};